const spearsBGSVG = `

<svg width="1034" height="633" viewBox="0 0 1034 633" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_2504_723)">
<path d="M415.981 194.953C418.733 194.953 420.963 192.725 420.963 189.977C420.963 187.228 418.733 185 415.981 185C413.23 185 411 187.228 411 189.977C411 192.725 413.23 194.953 415.981 194.953Z" fill="#E32A71"/>
</g>
<g filter="url(#filter1_d_2504_723)">
<path d="M577.981 18.9533C580.733 18.9533 582.963 16.7252 582.963 13.9766C582.963 11.2281 580.733 9 577.981 9C575.23 9 573 11.2281 573 13.9766C573 16.7252 575.23 18.9533 577.981 18.9533Z" fill="#E32A71"/>
</g>
<g filter="url(#filter2_d_2504_723)">
<path d="M377.381 90.2973C381.591 90.2973 385.005 86.8872 385.005 82.6806C385.005 78.4741 381.591 75.064 377.381 75.064C373.17 75.064 369.757 78.4741 369.757 82.6806C369.757 86.8872 373.17 90.2973 377.381 90.2973Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter3_d_2504_723)">
<path d="M581.105 195.717C582.886 195.717 584.329 194.275 584.329 192.496C584.329 190.717 582.886 189.275 581.105 189.275C579.324 189.275 577.881 190.717 577.881 192.496C577.881 194.275 579.324 195.717 581.105 195.717Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter4_d_2504_723)">
<path d="M677.327 384.639C681.373 384.639 684.654 381.362 684.654 377.32C684.654 373.277 681.373 370 677.327 370C673.28 370 670 373.277 670 377.32C670 381.362 673.28 384.639 677.327 384.639Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter5_d_2504_723)">
<path d="M606.897 148.862C610.944 148.862 614.224 145.585 614.224 141.542C614.224 137.5 610.944 134.222 606.897 134.222C602.851 134.222 599.57 137.5 599.57 141.542C599.57 145.585 602.851 148.862 606.897 148.862Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter6_d_2504_723)">
<path d="M718.327 624.639C722.373 624.639 725.654 621.362 725.654 617.32C725.654 613.277 722.373 610 718.327 610C714.28 610 711 613.277 711 617.32C711 621.362 714.28 624.639 718.327 624.639Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter7_d_2504_723)">
<path d="M897.327 238.639C901.373 238.639 904.654 235.362 904.654 231.32C904.654 227.277 901.373 224 897.327 224C893.28 224 890 227.277 890 231.32C890 235.362 893.28 238.639 897.327 238.639Z" fill="#E32A71"/>
</g>
<g filter="url(#filter8_d_2504_723)">
<path d="M49.8602 252.709C53.0966 252.709 55.7203 250.088 55.7203 246.855C55.7203 243.621 53.0966 241 49.8602 241C46.6237 241 44 243.621 44 246.855C44 250.088 46.6237 252.709 49.8602 252.709Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter9_d_2504_723)">
<path d="M421.812 534.617C423.917 534.617 425.624 532.912 425.624 530.808C425.624 528.705 423.917 527 421.812 527C419.707 527 418 528.705 418 530.808C418 532.912 419.707 534.617 421.812 534.617Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter10_d_2504_723)">
<path d="M296.773 137.734C298.878 137.734 300.585 136.029 300.585 133.926C300.585 131.822 298.878 130.117 296.773 130.117C294.668 130.117 292.961 131.822 292.961 133.926C292.961 136.029 294.668 137.734 296.773 137.734Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter11_d_2504_723)">
<path d="M384.103 224.198C386.369 224.198 388.206 222.362 388.206 220.099C388.206 217.835 386.369 216 384.103 216C381.837 216 380 217.835 380 220.099C380 222.362 381.837 224.198 384.103 224.198Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter12_d_2504_723)">
<path d="M373.103 333.198C375.369 333.198 377.206 331.363 377.206 329.099C377.206 326.835 375.369 325 373.103 325C370.837 325 369 326.835 369 329.099C369 331.363 370.837 333.198 373.103 333.198Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter13_d_2504_723)">
<path d="M640.023 257.212C642.289 257.212 644.125 255.377 644.125 253.113C644.125 250.85 642.289 249.015 640.023 249.015C637.757 249.015 635.92 250.85 635.92 253.113C635.92 255.377 637.757 257.212 640.023 257.212Z" fill="#F3EA22"/>
</g>
<g filter="url(#filter14_d_2504_723)">
<path d="M277.429 268.928C279.535 268.928 281.241 267.223 281.241 265.119C281.241 263.016 279.535 261.311 277.429 261.311C275.324 261.311 273.617 263.016 273.617 265.119C273.617 267.223 275.324 268.928 277.429 268.928Z" fill="#E32A71"/>
</g>
<g filter="url(#filter15_d_2504_723)">
<path d="M682.933 247.861C684.553 247.861 685.867 246.549 685.867 244.93C685.867 243.312 684.553 242 682.933 242C681.313 242 680 243.312 680 244.93C680 246.549 681.313 247.861 682.933 247.861Z" fill="#E32A71"/>
</g>
<g filter="url(#filter16_d_2504_723)">
<path d="M638.933 527.861C640.553 527.861 641.867 526.549 641.867 524.93C641.867 523.312 640.553 522 638.933 522C637.313 522 636 523.312 636 524.93C636 526.549 637.313 527.861 638.933 527.861Z" fill="#E32A71"/>
</g>
<g filter="url(#filter17_d_2504_723)">
<path d="M559.933 167.861C561.553 167.861 562.867 166.549 562.867 164.93C562.867 163.312 561.553 162 559.933 162C558.313 162 557 163.312 557 164.93C557 166.549 558.313 167.861 559.933 167.861Z" fill="#E32A71"/>
</g>
<g filter="url(#filter18_d_2504_723)">
<path d="M610.933 315.861C612.553 315.861 613.867 314.549 613.867 312.93C613.867 311.312 612.553 310 610.933 310C609.313 310 608 311.312 608 312.93C608 314.549 609.313 315.861 610.933 315.861Z" fill="#E32A71"/>
</g>
<g filter="url(#filter19_d_2504_723)">
<path d="M631.13 198.656C634.046 198.656 636.409 196.295 636.409 193.382C636.409 190.47 634.046 188.109 631.13 188.109C628.215 188.109 625.852 190.47 625.852 193.382C625.852 196.295 628.215 198.656 631.13 198.656Z" fill="#E32A71"/>
</g>
<g filter="url(#filter20_d_2504_723)">
<path d="M387.4 292.791C389.83 292.791 391.8 290.823 391.8 288.396C391.8 285.968 389.83 284 387.4 284C384.97 284 383 285.968 383 288.396C383 290.823 384.97 292.791 387.4 292.791Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter21_d_2504_723)">
<path d="M690.735 201.578C693.165 201.578 695.135 199.61 695.135 197.182C695.135 194.755 693.165 192.787 690.735 192.787C688.305 192.787 686.335 194.755 686.335 197.182C686.335 199.61 688.305 201.578 690.735 201.578Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter22_d_2504_723)">
<path d="M619.211 235.55C621.642 235.55 623.611 233.582 623.611 231.154C623.611 228.726 621.642 226.758 619.211 226.758C616.781 226.758 614.812 228.726 614.812 231.154C614.812 233.582 616.781 235.55 619.211 235.55Z" fill="white"/>
</g>
<g filter="url(#filter23_d_2504_723)">
<path d="M432.933 596.861C434.553 596.861 435.867 595.549 435.867 593.93C435.867 592.312 434.553 591 432.933 591C431.313 591 430 592.312 430 593.93C430 595.549 431.313 596.861 432.933 596.861Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter24_d_2504_723)">
<path d="M348.069 385.482C350.984 385.482 353.347 383.121 353.347 380.209C353.347 377.296 350.984 374.935 348.069 374.935C345.153 374.935 342.79 377.296 342.79 380.209C342.79 383.121 345.153 385.482 348.069 385.482Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter25_d_2504_723)">
<path d="M454.279 147.547C457.194 147.547 459.557 145.186 459.557 142.274C459.557 139.361 457.194 137 454.279 137C451.363 137 449 139.361 449 142.274C449 145.186 451.363 147.547 454.279 147.547Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter26_d_2504_723)">
<path d="M635.92 299.388C640.131 299.388 643.544 295.978 643.544 291.771C643.544 287.565 640.131 284.155 635.92 284.155C631.709 284.155 628.296 287.565 628.296 291.771C628.296 295.978 631.709 299.388 635.92 299.388Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter27_d_2504_723)">
<path d="M879.21 363.226C883.421 363.226 886.834 359.816 886.834 355.609C886.834 351.403 883.421 347.993 879.21 347.993C874.999 347.993 871.586 351.403 871.586 355.609C871.586 359.816 874.999 363.226 879.21 363.226Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter28_d_2504_723)">
<path d="M710.958 123.094C715.169 123.094 718.582 119.684 718.582 115.478C718.582 111.271 715.169 107.861 710.958 107.861C706.747 107.861 703.334 111.271 703.334 115.478C703.334 119.684 706.747 123.094 710.958 123.094Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter29_d_2504_723)">
<path d="M340.45 256.631C344.661 256.631 348.074 253.221 348.074 249.014C348.074 244.808 344.661 241.398 340.45 241.398C336.24 241.398 332.826 244.808 332.826 249.014C332.826 253.221 336.24 256.631 340.45 256.631Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter30_d_2504_723)">
<path d="M432.197 350.335C433.977 350.335 435.421 348.893 435.421 347.114C435.421 345.336 433.977 343.894 432.197 343.894C430.416 343.894 428.973 345.336 428.973 347.114C428.973 348.893 430.416 350.335 432.197 350.335Z" fill="#E32A71"/>
</g>
<g filter="url(#filter31_d_2504_723)">
<path d="M416.077 258.387C418.992 258.387 421.355 256.026 421.355 253.113C421.355 250.201 418.992 247.84 416.077 247.84C413.161 247.84 410.798 250.201 410.798 253.113C410.798 256.026 413.161 258.387 416.077 258.387Z" fill="white"/>
</g>
<g filter="url(#filter32_d_2504_723)">
<path d="M382.661 170.537C385.577 170.537 387.94 168.176 387.94 165.264C387.94 162.351 385.577 159.99 382.661 159.99C379.746 159.99 377.383 162.351 377.383 165.264C377.383 168.176 379.746 170.537 382.661 170.537Z" fill="white"/>
</g>
<g filter="url(#filter33_d_2504_723)">
<path d="M304.515 477.023C306.456 477.023 308.03 475.451 308.03 473.511C308.03 471.572 306.456 470 304.515 470C302.574 470 301 471.572 301 473.511C301 475.451 302.574 477.023 304.515 477.023Z" fill="white"/>
</g>
<g filter="url(#filter34_d_2504_723)">
<path d="M719.46 281.23C724.156 281.23 727.962 277.427 727.962 272.736C727.962 268.044 724.156 264.241 719.46 264.241C714.764 264.241 710.957 268.044 710.957 272.736C710.957 277.427 714.764 281.23 719.46 281.23Z" fill="white"/>
</g>
<g filter="url(#filter35_d_2504_723)">
<path d="M154.901 346.243C159.597 346.243 163.404 342.44 163.404 337.749C163.404 333.058 159.597 329.254 154.901 329.254C150.205 329.254 146.398 333.058 146.398 337.749C146.398 342.44 150.205 346.243 154.901 346.243Z" fill="white"/>
</g>
<g filter="url(#filter36_d_2504_723)">
<path d="M490.515 179.023C492.456 179.023 494.03 177.451 494.03 175.511C494.03 173.572 492.456 172 490.515 172C488.574 172 487 173.572 487 175.511C487 177.451 488.574 179.023 490.515 179.023Z" fill="white"/>
</g>
<g filter="url(#filter37_d_2504_723)">
<path d="M556.515 112.023C558.456 112.023 560.03 110.451 560.03 108.511C560.03 106.572 558.456 105 556.515 105C554.574 105 553 106.572 553 108.511C553 110.451 554.574 112.023 556.515 112.023Z" fill="white"/>
</g>
<g filter="url(#filter38_d_2504_723)">
<path d="M596.643 365.563C598.584 365.563 600.158 363.99 600.158 362.051C600.158 360.112 598.584 358.54 596.643 358.54C594.702 358.54 593.128 360.112 593.128 362.051C593.128 363.99 594.702 365.563 596.643 365.563Z" fill="white"/>
</g>
<g filter="url(#filter39_d_2504_723)">
<path d="M430.143 316.364C432.084 316.364 433.658 314.792 433.658 312.852C433.658 310.913 432.084 309.341 430.143 309.341C428.202 309.341 426.628 310.913 426.628 312.852C426.628 314.792 428.202 316.364 430.143 316.364Z" fill="white"/>
</g>
<g filter="url(#filter40_d_2504_723)">
<path d="M665.4 451.791C667.83 451.791 669.8 449.823 669.8 447.396C669.8 444.968 667.83 443 665.4 443C662.97 443 661 444.968 661 447.396C661 449.823 662.97 451.791 665.4 451.791Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter41_d_2504_723)">
<path d="M159.884 185.764C165.066 185.764 169.266 181.568 169.266 176.392C169.266 171.216 165.066 167.02 159.884 167.02C154.703 167.02 150.503 171.216 150.503 176.392C150.503 181.568 154.703 185.764 159.884 185.764Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter42_d_2504_723)">
<path d="M487.601 109.623C491.811 109.623 495.225 106.213 495.225 102.006C495.225 97.7997 491.811 94.3896 487.601 94.3896C483.39 94.3896 479.977 97.7997 479.977 102.006C479.977 106.213 483.39 109.623 487.601 109.623Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter43_d_2504_723)">
<path d="M524.4 154.791C526.83 154.791 528.8 152.823 528.8 150.396C528.8 147.968 526.83 146 524.4 146C521.97 146 520 147.968 520 150.396C520 152.823 521.97 154.791 524.4 154.791Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter44_d_2504_723)">
<path d="M301.464 323.987C303.894 323.987 305.864 322.019 305.864 319.592C305.864 317.164 303.894 315.196 301.464 315.196C299.034 315.196 297.064 317.164 297.064 319.592C297.064 322.019 299.034 323.987 301.464 323.987Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter45_d_2504_723)">
<path d="M392.4 479.791C394.83 479.791 396.8 477.823 396.8 475.396C396.8 472.968 394.83 471 392.4 471C389.97 471 388 472.968 388 475.396C388 477.823 389.97 479.791 392.4 479.791Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter46_d_2504_723)">
<path d="M690.735 337.458C693.165 337.458 695.135 335.49 695.135 333.062C695.135 330.635 693.165 328.667 690.735 328.667C688.305 328.667 686.335 330.635 686.335 333.062C686.335 335.49 688.305 337.458 690.735 337.458Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter47_d_2504_723)">
<path d="M987.744 160.103C990.659 160.103 993.022 157.742 993.022 154.829C993.022 151.917 990.659 149.556 987.744 149.556C984.828 149.556 982.465 151.917 982.465 154.829C982.465 157.742 984.828 160.103 987.744 160.103Z" fill="#08FCC9"/>
</g>
<g filter="url(#filter48_d_2504_723)">
<path d="M1020.6 443.479C1023.03 443.479 1025 441.511 1025 439.084C1025 436.656 1023.03 434.688 1020.6 434.688C1018.17 434.688 1016.2 436.656 1016.2 439.084C1016.2 441.511 1018.17 443.479 1020.6 443.479Z" fill="#1CADE3"/>
</g>
<g filter="url(#filter49_d_2504_723)">
<path d="M963.19 521.432C966.295 521.432 968.812 518.915 968.812 515.81C968.812 512.705 966.295 510.188 963.19 510.188C960.085 510.188 957.567 512.705 957.567 515.81C957.567 518.915 960.085 521.432 963.19 521.432Z" fill="white"/>
</g>
<g filter="url(#filter50_d_2504_723)">
<path d="M14.6223 109.396C17.7275 109.396 20.2447 106.879 20.2447 103.774C20.2447 100.669 17.7275 98.1514 14.6223 98.1514C11.5172 98.1514 9 100.669 9 103.774C9 106.879 11.5172 109.396 14.6223 109.396Z" fill="white"/>
</g>
<g filter="url(#filter51_d_2504_723)">
<path d="M35.9642 492.624C38.8795 492.624 41.2429 490.263 41.2429 487.35C41.2429 484.437 38.8795 482.076 35.9642 482.076C33.0489 482.076 30.6855 484.437 30.6855 487.35C30.6855 490.263 33.0489 492.624 35.9642 492.624Z" fill="#E32A71"/>
</g>
<g filter="url(#filter52_d_2504_723)">
<path d="M539.503 553.989C544.199 553.989 548.005 550.186 548.005 545.495C548.005 540.803 544.199 537 539.503 537C534.807 537 531 540.803 531 545.495C531 550.186 534.807 553.989 539.503 553.989Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_2504_723" x="402.968" y="176.968" width="26.0267" height="26.017" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter1_d_2504_723" x="564.968" y="0.968105" width="26.0267" height="26.017" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter2_d_2504_723" x="361.725" y="67.0321" width="31.3118" height="31.2971" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter3_d_2504_723" x="569.849" y="181.243" width="22.512" height="22.5057" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter4_d_2504_723" x="661.968" y="361.968" width="30.7171" height="30.7033" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter5_d_2504_723" x="591.538" y="126.191" width="30.7171" height="30.7033" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter6_d_2504_723" x="702.968" y="601.968" width="30.7171" height="30.7033" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter7_d_2504_723" x="881.968" y="215.968" width="30.7171" height="30.7033" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter8_d_2504_723" x="35.9681" y="232.968" width="27.7845" height="27.7728" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter9_d_2504_723" x="409.968" y="518.968" width="23.6878" height="23.6805" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter10_d_2504_723" x="284.929" y="122.085" width="23.6878" height="23.6805" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter11_d_2504_723" x="371.968" y="207.968" width="24.2689" height="24.2614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter12_d_2504_723" x="360.968" y="316.968" width="24.2689" height="24.2614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter13_d_2504_723" x="627.888" y="240.983" width="24.2689" height="24.2614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 0 0.117647 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter14_d_2504_723" x="265.585" y="253.279" width="23.6878" height="23.6805" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter15_d_2504_723" x="671.968" y="233.968" width="21.93" height="21.9248" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter16_d_2504_723" x="627.968" y="513.968" width="21.93" height="21.9248" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter17_d_2504_723" x="548.968" y="153.968" width="21.93" height="21.9248" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter18_d_2504_723" x="599.968" y="301.968" width="21.93" height="21.9248" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter19_d_2504_723" x="617.82" y="180.077" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter20_d_2504_723" x="374.968" y="275.968" width="24.8636" height="24.8552" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter21_d_2504_723" x="678.303" y="184.755" width="24.8636" height="24.8552" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter22_d_2504_723" x="606.78" y="218.726" width="24.8636" height="24.8553" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter23_d_2504_723" x="421.968" y="582.968" width="21.93" height="21.9248" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter24_d_2504_723" x="334.758" y="366.903" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter25_d_2504_723" x="440.968" y="128.968" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter26_d_2504_723" x="620.264" y="276.123" width="31.3118" height="31.2972" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter27_d_2504_723" x="863.554" y="339.961" width="31.3118" height="31.2972" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter28_d_2504_723" x="695.302" y="99.8292" width="31.3118" height="31.2972" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter29_d_2504_723" x="324.794" y="233.366" width="31.3118" height="31.2972" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter30_d_2504_723" x="420.941" y="335.862" width="22.512" height="22.5057" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter31_d_2504_723" x="402.766" y="239.808" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter32_d_2504_723" x="369.351" y="151.958" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter33_d_2504_723" x="292.968" y="461.968" width="23.0931" height="23.0866" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter34_d_2504_723" x="702.925" y="256.209" width="33.0696" height="33.0528" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter35_d_2504_723" x="138.367" y="321.222" width="33.0696" height="33.0528" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter36_d_2504_723" x="478.968" y="163.968" width="23.0931" height="23.0866" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter37_d_2504_723" x="544.968" y="96.9681" width="23.0931" height="23.0866" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter38_d_2504_723" x="585.096" y="350.508" width="23.0931" height="23.0866" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter39_d_2504_723" x="418.596" y="301.309" width="23.0931" height="23.0866" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter40_d_2504_723" x="652.968" y="434.968" width="24.8636" height="24.8552" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter41_d_2504_723" x="142.471" y="158.988" width="34.8265" height="34.8085" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter42_d_2504_723" x="471.945" y="86.3578" width="31.3118" height="31.2971" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter43_d_2504_723" x="511.968" y="137.968" width="24.8636" height="24.8553" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter44_d_2504_723" x="289.033" y="307.164" width="24.8636" height="24.8553" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter45_d_2504_723" x="379.968" y="462.968" width="24.8636" height="24.8552" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter46_d_2504_723" x="678.303" y="320.635" width="24.8636" height="24.8552" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter47_d_2504_723" x="974.433" y="141.524" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0313726 0 0 0 0 0.988235 0 0 0 0 0.788235 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter48_d_2504_723" x="1008.17" y="426.656" width="24.8636" height="24.8552" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.678431 0 0 0 0 0.886275 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter49_d_2504_723" x="949.535" y="502.156" width="27.3089" height="27.3084" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter50_d_2504_723" x="0.968105" y="90.1195" width="27.3089" height="27.3084" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter51_d_2504_723" x="22.6537" y="474.045" width="26.6214" height="26.6109" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.890196 0 0 0 0 0.164706 0 0 0 0 0.443137 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
<filter id="filter52_d_2504_723" x="522.968" y="528.968" width="33.0696" height="33.0528" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4.01595"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2504_723"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2504_723" result="shape"/>
</filter>
</defs>
</svg>

`

export default spearsBGSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/spearsBGSVG.js